import Vue from 'vue'
import App from './App.vue'
import 'at-ui-style'
import AtUI from 'at-ui'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import Web3 from 'web3'

Vue.use(AtUI)

sync(store, router)

window.web3 = typeof web3 !== 'undefined'
  ? new Web3(web3.currentProvider)
  : null

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App />',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js